module.exports.config = {
  apiGateway: {    URL: "https://s614l2psa5.execute-api.ca-central-1.amazonaws.com/v1",
    REGION: 'ca-central-1'
  },
  fourlyticsId: 5
}

